import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/analytics/spend");

export const Route = createFileRoute("/analytics/spend")({
  head: () => ({
    meta: [
      { title: "Spend — LevelLoad" },
      { name: "description", content: "Spend — LevelLoad transport planning." },
      { property: "og:title", content: "Spend — LevelLoad" },
      { property: "og:description", content: "Spend — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
